import { Directive, ElementRef, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { BehaviorSubject, filter, fromEvent, Subject, takeUntil } from 'rxjs';
import { AutofocusDirective } from '../../basics/models/bosch-ui-autofocus-directive.interface';

@Directive({
  selector: '[boschUiInputAutofocus]',
})
export class BoschUiInputAutofocusDirective implements OnInit, OnDestroy, AutofocusDirective {
  private readonly input = inject(ElementRef, { host: true });
  @Input() set boschUiInputAutofocus(autofocus: boolean) {
    this._autofocus$.next(autofocus);
  }

  private _autofocus$ = new BehaviorSubject<boolean>(false);
  private _unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this._autofocus$
      .pipe(filter(Boolean), takeUntil(this._unsubscribe$))
      .subscribe(() => this.input.nativeElement.focus());

    fromEvent(this.input.nativeElement, 'blur')
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe(() => this._autofocus$.next(false));
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
  }

  public focus(): void {
    this._autofocus$.next(true);
  }
}
